<template>
  <div class="form-group">
    <select v-model="selectedLloc" class="form-input" @change="emitChange">
      <option disabled value="">Selecciona un lloc</option>
      <option value="Parròquia">Parròquia</option>
      <option value="Espai Temple">Espai Temple</option>
      <option value="Espai Oratori">Espai Oratori</option>
      <option value="Espai Jardí">Espai Jardí</option>
      <option value="Sense Cerimònia">Sense Cerimònia</option>
    </select>

    <div v-if="selectedLloc === 'Parròquia'" style="margin-top: 1em">
      <select
        v-model="selectedParroquia"
        class="form-input"
        @change="emitChange"
      >
        <option disabled value="">Tria una parròquia</option>
        <option value="4100961 Parròquia Montserrat">
          Parròquia Montserrat
        </option>
        <option value="4100962 Parròquia Sagrada Familia">
          Parròquia Sagrada Família
        </option>
        <option value="4101132 Parròquia Sant Pau">Parròquia Sant Pau</option>
        <option value="4101133 Parròquia Sant Cristòfor">
          Parròquia Sant Cristòfor
        </option>
        <option value="4101134 Parròquia Maria Auxiliadora">
          Parròquia Maria Auxiliadora
        </option>
        <option value="4101135 Parròquia Sant Llorenç">
          Parròquia Sant Llorenç
        </option>
        <option value="4101136 Parròquia Mare de Déu del Roser">
          Parròquia Mare de Déu del Roser
        </option>
        <option value="4101137 Parròquia Mare de Déu del Carme">
          Parròquia Mare de Déu del Carme
        </option>
        <option value="4101138 Parròquia Sant Josep">
          Parròquia Sant Josep
        </option>
        <option value="4101139 Parròquia Sant Pere">Parròquia Sant Pere</option>
        <option value="4101140 Parròquia Sant Esperit">
          Parròquia Sant Esperit
        </option>
        <option value="4101143 Parròquia Sant Joan Baptista">
          Parròquia Sant Joan Baptista
        </option>
        <option value="4101144 Parròquia Sant Valentí">
          Parròquia Sant Valentí
        </option>
        <option value="4101145 Parròquia Santa Maria de Les Arenes">
          Parròquia Santa Maria de les Arenes
        </option>
        <option value="4101146 Parròquia Sant Martí Sorbet">
          Parròquia Sant Martí Sorbet
        </option>
        <option value="4101148 Parròquia Santa Maria d'Ullastrell">
          Parròquia Santa Maria d'Ullastrell
        </option>
        <option value="4101149 Parròquia Sant Vicenç de Castellbisbal">
          Parròquia Sant Vicenç de Castellbisbal
        </option>
      </select>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  props: {
    llocCerimonia: {
      type: String,
      required: false,
      default: "",
    },
    parroquia: {
      type: String,
      required: false,
      default: "",
    },
  },
  emits: ["update:llocCerimonia", "update:parroquia"],
  setup(props, { emit }) {
    const selectedLloc = ref(props.llocCerimonia);
    const selectedParroquia = ref(props.parroquia);

    watch(
      () => props.llocCerimonia,
      (newVal) => {
        selectedLloc.value = newVal;
      },
      { immediate: true },
    );

    watch(
      () => props.parroquia,
      (newVal) => {
        selectedParroquia.value = newVal;
      },
      { immediate: true },
    );

    const emitChange = () => {
      emit("update:llocCerimonia", selectedLloc.value);
      emit(
        "update:parroquia",
        selectedLloc.value === "Parròquia" ? selectedParroquia.value : "",
      );
    };

    return {
      selectedLloc,
      selectedParroquia,
      emitChange,
    };
  },
});
</script>

<style scoped></style>
